import { renderPdpPage } from './product/index';

renderPdpPage({ isHandbagPdp: true });
import('./product/components/PdpBuilder/lazyInit').then((module) => module.renderPdpBuilder());
